<mat-toolbar class="text-uppercase">
  <mat-toolbar-row>
    <span>Grupos</span>
    <span class="spacer"></span>
    <button
      mat-raised-button
      color="primary"
      data-cy="new"
      (click)="openGroup()"
    >
      Novo
    </button>
  </mat-toolbar-row>
</mat-toolbar>

<table mat-table [dataSource]="model" class="grupos">
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let group" class="actions">
      <fa-icon [icon]="faListAlt" (click)="openGroup(group.id)"></fa-icon>
    </td>
  </ng-container>

  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>Nome</th>
    <td mat-cell *matCellDef="let group">{{ group.name }}</td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
